<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M34.12 32l16.44-16.44a1.5 1.5 0 00-2.12-2.12L32 29.88 15.56 13.44a1.5 1.5 0 00-2.12 2.12L29.88 32 13.44 48.44a1.49 1.49 0 000 2.12 1.5 1.5 0 002.12 0L32 34.12l16.44 16.44a1.5 1.5 0 002.12 0 1.49 1.49 0 000-2.12z"/></svg>